import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";

import Table from "../Table";
import DataTable from "../DataTable";
import { useLocation, useNavigate } from "react-router-dom";
import TotalRegisteredMembersDataTable from "./TotalRegisteredMembersDataTable";
import axios from "axios";
import Loader from "../Loader";
import voucherDateAndTimeFormatter from "../../utilities/voucherDateAndTimeFormatter";
import NewVerifiedMembersDataTable from "./NewVerifiedMembersDataTable";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";

const LatestVerificationDetailsPage = () => {
  const [loading, setLoading] = useState(false);
  const [newVerificationMembershipList, setNewVerifiedMembersDetails] =
    useState([]);

  // const navigate = useNavigate();
  // const location = useLocation();
  // const { ActiveMembersData } = location.state;

  const handleGetNewVerifiedAdvocateDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_latest_verification_advocate_list`
      );

      console.log("new verified advocate data", response.data);
      if (response.data.response.statusCode === 200) {
        setNewVerifiedMembersDetails(response.data.newVerificationList);
      } else {
        setNewVerifiedMembersDetails([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatRegData = voucherDateAndTimeFormatter(
    newVerificationMembershipList,
    [
      "verificationDate",
      "appliedDate",
      "dateOfBirth",
      "mentorJoiningDate",
      "retirementYear",
    ]
  );

  const activeMemberTableColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "verificationDate",
      headerName: "VerificationDate Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "mobileNo",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  useEffect(() => {
    handleGetNewVerifiedAdvocateDetails();
  }, []);

  return (
    <>
      {loading && <Loader />}

      <MDBContainer fluid>
        <NewVerifiedMembersDataTable
          TableData={formatRegData}
          tableName="Latest Verification "
          TableColumns={activeMemberTableColumns}
          height={750}
        />
      </MDBContainer>
    </>
  );
};

export default LatestVerificationDetailsPage;
